import debug from 'debug';
const log = debug('itp:core:downloads');
export function showFileInNewTab(blob, reportName) {
    log('showFileInNewTab: fileName=`{%s}`', reportName);
    window.open(URL.createObjectURL(blob));
}
export function showFileInNewWindow(blob, reportName) {
    const newWindow = window.open('', reportName, 'width=800,height=1200');
    if (newWindow) {
        setTimeout(() => {
            const dataUrl = window.URL.createObjectURL(blob);
            const title = newWindow.document.createElement('title');
            const iframe = newWindow.document.createElement('iframe');
            title.appendChild(document.createTextNode(reportName));
            newWindow.document.head.appendChild(title);
            iframe.setAttribute('src', dataUrl);
            iframe.setAttribute('width', '100%');
            iframe.setAttribute('height', '100%');
            newWindow.document.body.appendChild(iframe);
            setTimeout(() => {
                window.URL.revokeObjectURL(dataUrl);
            }, 100);
        }, 100);
    }
    else {
        alert('To display reports, please disable any pop-blockers for this page and try again.');
    }
}
//# sourceMappingURL=display.js.map